// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext } from "react";

export interface OrderDetailsPaymentInfoStyles {
    titleText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    container?: InjectableCss;
    data?: TypographyPresentationProps;
}

export const orderDetailsPaymentInfoStyles: OrderDetailsPaymentInfoStyles = {};

const styles = orderDetailsPaymentInfoStyles;

const OrderDetailsPaymentInfo: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }
    const creditCardInfo = order.properties["maskedCreditCardDetails"];

    return (
        <>
            {!creditCardInfo ? (
                <>{createWidgetElement("OrderDetails/OrderDetailsPaymentTerms", { fields: {} })}</>
            ) : (
                <StyledWrapper {...styles.container}>
                    <StyledWrapper {...styles.wrapper}>
                        <Typography {...styles.titleText}>{translate("Payment Method")} </Typography>
                        <Typography {...styles.data}>{creditCardInfo}</Typography>
                    </StyledWrapper>
                    {createWidgetElement("OrderDetails/OrderDetailsCreditCardBillingAddress", { fields: {} })}
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsPaymentInfo,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
